import HeaderWithIcons from '@components/app/HeaderWithIcons';
import MuharramCompetition from '@components/competitions/levels/muharram-no-day';
import {appConfig} from '@config';
import {Box, Button, Link, Skeleton, Typography} from '@mui/material';
import axios from 'axios';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useLoaderData, useSearchParams} from 'react-router-dom';
import {ICompetition} from './ICompetitions';

let referrerFrom = document.referrer;
export default function MuharramLevelCompetition() {
	const {t} = useTranslation();
	// const location = useLocation();
	const [queryParameters] = useSearchParams();
	const [referrer] = useState<string>(referrerFrom);
	// const [searchParams] = useSearchParams();
	// const [searchParams, setSearchParams] = useSearchParams();
	const [competition, setCompetition] = useState<ICompetition | undefined>();
	const [referral] = useState<string>(queryParameters.get('referral') as string);
	let competitionObject = useLoaderData() as ICompetition;
	useEffect(() => {
		setCompetition(competitionObject);
	}, []);
	const renderAction = (competition: ICompetition) => {
		let status = <Button component={Link} href={competition.winnerLink} className="mx-3">{t('winner_list')}</Button>;
		switch (competition.status) {
			case 'enabled':
				status = <Button component={Link} href={competition.link} className="mx-3">{t('start_competition')}</Button>;
				break;
			case 'remain':
				status = <Typography sx={{color: 'grey.600'}}
				                     className="mx-4">{t('remain_until_start', {day: competition.remainDay})}</Typography>;
		}
		return status;
	};
	return (
		<>
			<HeaderWithIcons title={competition?.name ?? <Skeleton className="w-24"/>} home={true} backUrl={'/'}/>
			<Box className="flex flex-col gap-y-2" sx={{
				borderColor: (theme) => theme.palette.mode === 'light' ? 'grey.100' : 'background.paper',
				bgcolor: (theme) => theme.palette.mode === 'light' ? 'secondary.A200' : 'grey.700'
			}}>
				{
					competition?.id == 5 && (
						<>
							<MuharramCompetition competition={competition} referrer={referrer}/>
						</>
					)
				}
			</Box>
		</>
	);
}

interface loader {
	request: Request;
	params: {};
}

export async function competitionMuharramLoader(data: loader) {
	const res = await axios({
		// @ts-ignore
		url: `${appConfig.competition2.url}competition/4`,
		method: 'GET'
	});
	if (res.data.success) {
		return res.data.result;
	} else {
		return res.data.error;
	}
}
